'use client'

import MUIStack from '@mui/material/Stack'
import { useUrlStore } from '@repo/store/useUrlStore'
import { BreadcrumbItem } from '../BreadcrumbItem/BreadcrumbItem'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

export const Breadcrumb = () => {
  const { breadcrumbs, isHome, getLastUrlSegment } = useUrlStore()
  const { sidebarMode } = useGlobalSettingsStore()
  const leftOffset = sidebarMode === 'expanded' ? '264px' : '64px'

  if (isHome || !breadcrumbs?.length) return null

  let breadcrumbsToDisplay = [...breadcrumbs]

  // get the url segment of the last breadcrumb item
  const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1]
  const lastBreadcrumbUrlSegment = lastBreadcrumb.urlSegment

  const { lastUrlSegment, lastUrlSegmentLabel } = getLastUrlSegment()

  if (lastUrlSegment !== lastBreadcrumbUrlSegment) {
    // add the title of the current page as the last breadcrumb item
    breadcrumbsToDisplay.push({
      label: lastUrlSegmentLabel,
      urlSegment: lastUrlSegment
    })
  }

  return (
    <MUIStack
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      data-testid="Breadcrumb"
      sx={{
        position: 'fixed',
        width: '100%',
        top: '70px',
        left: leftOffset,
        height: '70px',
        padding: '0 24px',
        backgroundColor: 'background.paper',
        transition: 'left 250ms',
        zIndex: 10
      }}
    >
      {breadcrumbsToDisplay.map((item, index) => {
        return (
          <BreadcrumbItem
            key={`${item.label}-${item.urlSegment}-${index}`}
            breadcrumb={item}
            isLast={index === breadcrumbsToDisplay.length - 1}
          />
        )
      })}
    </MUIStack>
  )
}
